<button class="arrow-button left" (click)="previousClicked('month')">
  <img src="assets/img/icons/chevron-left-brown-2.svg" />
</button>
<span class="month">{{ periodLabel | uppercase }}</span>
<button class="arrow-button" (click)="nextClicked('month')">
  <img class="right" src="assets/img/icons/chevron-left-brown-2.svg" />
</button>
